import React from 'react';
import { QueryResult, useQuery } from '@apollo/client';
import { MAX_WIDGET_ITEMS } from '../../../constants/widget';
import {
  SortDirection,
  FetchRecentlyCreatedQuotesForHomePageInPpcQueryVariables,
  FetchRecentlyCreatedQuotesForHomePageInPpcQuery,
} from '@css-xp/graphtypes/src/generated-types-sxp';
import { ProxyGraphClients, abgGraphqlClient } from '@atlassian/temp-client-utils';
import { QuoteV2 } from '@atlassian/cssxp-types-quote';
import { fetchRecentlyCreatedQuotesForHomePageInPPC } from './queries/fetch-recently-generated-quotes-for-home-page';

type ChildrenProp = (
  args: QueryResult<
    FetchRecentlyCreatedQuotesForHomePageInPpcQuery,
    FetchRecentlyCreatedQuotesForHomePageInPpcQueryVariables
  >
) => JSX.Element;

export const RecentlyGeneratedQuotesQueryWrapper = ({
  txaId,
  children,
}: {
  txaId: string;
  children: ChildrenProp;
}): JSX.Element => {
  const client = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.SXP), []);
  const queryResult = useQuery<
    FetchRecentlyCreatedQuotesForHomePageInPpcQuery,
    FetchRecentlyCreatedQuotesForHomePageInPpcQueryVariables
  >(fetchRecentlyCreatedQuotesForHomePageInPPC, {
    client,
    variables: {
      searchOptions: {
        first: MAX_WIDGET_ITEMS,
        sort: {
          sortFields: ['createdDate', 'id'],
          sortFieldsDirections: [SortDirection.DESC, SortDirection.DESC],
        },
      },
      filterOptions: {
        and: [
          { key: 'status', value: QuoteV2.QuoteStatus.OPEN },
          { key: 'transactionAccountId', value: txaId },
          { key: 'sourceSystem', value: 'CCP' },
        ],
      },
    },
    fetchPolicy: 'cache-and-network',
  });

  return children(queryResult);
};
